import React from 'react';

function SvgHomePageArrow() {
  return (
    <svg width="18px" height="7px">
      <path
        fill-rule="evenodd"
        stroke="rgb(2, 2, 2)"
        stroke-width="0px"
        stroke-linecap="butt"
        stroke-linejoin="miter"
        fill="rgb(30, 147, 221)"
        d="M18.000,3.500 L12.333,6.1000 L12.333,4.200 L-0.000,4.200 L-0.000,2.800 L12.333,2.800 L12.333,0.000 L18.000,3.500 Z"
      />
    </svg>
  );
}

export default SvgHomePageArrow;
